import React, {useState, useEffect} from 'react';
import ReactApexChart from 'react-apexcharts'; 
import {
  Progress, Table, useDispatch, useSelector,DatePicker, Spin, Modal, Form, Select, Divider ,PlusCircleFilled,message,Button 
} from '../AntComponent';
import InnerDocManager from './InnerDocManager';
import { differenceInCalendarDays} from 'date-fns';
import {getGenDocument,getDocStorageData,getRecentDocumentData, saveDocumentType, getDocType,getDocumnetType, deleteDocumentType} from '../../store/actions/DocumentManagerAction'

export default function DocumentManager (){
  const dispatch = useDispatch()
  const [form] = Form.useForm();
  const { profileInfo } = useSelector(state => state.userPrf);
  const {genDoc,success2,docStorage,recDoc,success3, success1, success,loading,loading2, loading3,docType,success5,documentTypes,
     success6,delDocType,success4,loading4, error6,loading6} = useSelector(state => state.documentManager);
  const tenantID = profileInfo?.data?.appUser?.tenantID;
  const productID = profileInfo?.data?.tenantDetail?.kProductID;
  const locationID = profileInfo?.data?.location[0]?.locationID;
  const appUserID = profileInfo?.data?.appUser?.appuserID;
  const [usageData, setUsageData] = useState([]);
  const [usageDate, setUsageDate] = useState([]);
  const [discStatus, setDiscStatus] = useState([]);
  const [searchTableVal, setsearchTableval] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalStorage, setTotalStorage] = useState(0);
  const [totalFreeSpace, setTotalFreeSpace] = useState(0);
  const [usedSpace, setUsedSpace] = useState(0);
  const [showParent, setShowParent] = useState(true);
  const [showChild, setShowChild] = useState(false);
  const [showDocument, setShowDocument] = useState(true);
  const today = new Date();
  const [date, setDate] = useState();
  //doc storage
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const successmsg = showSuccessMsg ? success3 : null;
  // doc type
  const [showSuccessMsg1, setShowSuccessMsg1] = useState(false);
  const successmsg1 = showSuccessMsg1 ? success2 : null;
  // recent file
  const [showSuccessMsg2, setShowSuccessMsg2] = useState(false);
  const successmsg2 = showSuccessMsg2 ? success : null;
  // delete doc type 
  const [showSuccessMsg3, setShowSuccessMsg3] = useState(false);
  const successmsg3 = showSuccessMsg3 ? success6 : null;
  const [showErrorMsg3, setShowErrorMsg3] = useState(false);
  const errormsg3 = showErrorMsg3 ? error6 : null;
 // save doc type 
  const [showSuccessMsg4, setShowSuccessMsg4] = useState(false);
  const successmsg4 = showSuccessMsg4 ? success4 : null;

  const [documentType,setDocumentType]= useState([]);
  const [documentStorage, setDocumentStorage] =  useState([]);
  const [usedStorage, setUsedStorage] = useState(0);
  const[month, setMonth] = useState()
  const[year, setYear] = useState()
  const [recentFileList, setRecentFileList]= useState([]);
  //modal 
  const [openModal , setOpenModal] = useState(false);
  const [selectedDocValue, setSelectedDocValue] =  useState(0)
  const [selectedDoclabel, setSelectedDocLabel] =  useState(0)

  const docTypeList = docType?.data?.map((item) => {
    return {
      label: item.docType,
      value: item.docTypeID
    }
  });

  const getDocumentDatas =()=>{
      let ids1 = `${tenantID}/${locationID}`
     dispatch(getDocumnetType(ids1))
  }
  const handleModalOpen =()=>{
    setOpenModal(true);
    getDocumentDatas();
  }
  useEffect(()=>{
    if(tenantID){
      let ids = `${tenantID}`;
     dispatch(getDocType(ids)) 
     getDocumentDatas()
    }
  }, [tenantID])

  const handleSelectChange = (selectedValues) => {
    const selectedLabels = docTypeList
      .filter((option) => selectedValues.includes(option.value))
      .map((option) => option.label);

      setSelectedDocLabel(selectedLabels);
      setSelectedDocValue(selectedValues)
  };

  const handleDeselect = (value) => {
    const hasMatchingDocTypeID = documentTypes?.data?.some(item => item.docTypeID === value);
    if(hasMatchingDocTypeID){
      let ids = `${tenantID}/${locationID}/${value}`
      dispatch(deleteDocumentType(ids))
      
    } 
  };

  useEffect(()=>{
    if(successmsg3){
      if(delDocType?.message =="Deleted Successfully"){
        message.success("Document Type deleted sucessfully");
        setShowSuccessMsg3(false)
        getDocumentDatas()
      }
    }
    else if(errormsg3){
      message.error(delDocType?.message)
    }
  },[successmsg3,errormsg3])

  useEffect(()=>{
    if(successmsg4){
      message.success("Document Type saved Successfully");
      setShowSuccessMsg4(false);
      setOpenModal(false)
    }
  },[successmsg4])
  useEffect(()=>{
    setShowSuccessMsg3(true)
    setShowErrorMsg3(true)
  },[loading6])

  useEffect(()=>{
      const docTypeIds = documentTypes?.data?.map(item => item.docTypeID);
      const commaSeparatedIds = docTypeIds?.join(',');
      if(documentTypes?.data.length == 0){
        form.setFieldsValue({
          docType: [],
        });
      }else if (commaSeparatedIds) {
        const arrayValue = commaSeparatedIds?.split(',').map(Number);
        form.setFieldsValue({
          docType: arrayValue,
        });
      }
  },[success5])
  const state = {
    options: {
    
      plotOptions: {
        bar: {
          dataLabels: {
            position: "top" 
          }
        }
      },
      dataLabels: {
        enabled: false,
        // formatter: function(val) {
        //   return Number(val).toLocaleString() + "€";
        // },
        offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#2dcab2"]
        }
      },
      xaxis: {
        type: 'date',
        tickAmount:4,
        categories: usageDate,
        position: "bottom",
        labels: {
          offsetY: 0
        },
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        crosshairs_: {
          fill: {
            type: "gradient",
            gradient: {
              colorFrom: "#D8E3F0",
              colorTo: "#BED1E6",
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5
            }
          }
        },
        tooltip: {
          enabled: false,
          offsetY: -35
        }
      },
      fill: {
        gradient: {
          shade: "light",
          type: "horizontal",
          shadeIntensity: 0.25,
          gradientToColors: undefined,
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [50, 0, 100, 100]
        },
        colors: ["#2dcab2"]
      },
      yaxis: {
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: true
        },
        labels: {
          show: true,
          // formatter: function(val) {
          //   return Number(val).toLocaleString() + "€";
          // }
        }
      },
      title: {
        text: "GB used",
        floating: true,
        offsetY: 0,
        align: "center",
        style: {
          color: "#444",
          fontSize:"18px",
          position: 'relative',
        },
      },
      subtitle: {
        text: "", 
        offsetY: 10, 
        style: {
          fontSize: '12px',
          fontWeight: 'bold',
          color: '#444',
        },
    
      },
      chart: {
        animations: {
          enabled: false
        },
        toolbar: {
          show: false
        },
      }
    },
    series: [
      {
        name: "tezts",
        data: usageData,
        color: "#08C1A4",
      }
    ]
  };
  const option1 = {
    colors: ["#36A2EB", "#ff6384"],
    series: discStatus,
    chart: {
      width: 360,
      type: 'donut',
    },
    labels: ['Free Space', 'Used Space'],
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
      },
    },
    dataLabels: {
      enabled: true,
    },
    // fill: {
    //   type: 'gradient',
    // },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        stops: [0, 90, 100],
      },
    },
    legend: {
      show: true,
      fontSize: '12px',
      position: 'top',
      labels: {
        useSeriesColors: true,
      },
      itemMargin: {
        horizontal: 10,
        vertical: 0,
      },
      
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'top',
          },
        },
      },
    ],
  } 
  const columns = [
    {
      title: 'Document Name',
      dataIndex: 'documentName',
      key: 'documentName',
      render: (text) => <span className="text-start">{text}</span>,
    },
    {
      title: 'Size',
      dataIndex: 'fileSize',
      key: 'fileSize',
      width: 150,
      render: (text) => <span className="text-start">{text}</span>,
    },
    {
      title: 'Document Type',
      dataIndex: 'docType',
      key: 'docType',
      render: (text) => <span className="text-start">{text}</span>,
    },
    {
      title: 'createdOn',
      dataIndex: 'createdOn',
      key: 'createdOn',
      width: 250,
      render: (text) => (
        <span className="text-start">
          {new Date(text).toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          })}
        </span>
      ),
    },
  ];
  const expireFileList = [
    {
      "documentName": "proposal.docx",
      "size": "2.9 MB",
      "ExpiredDays": "20 days",
      "documentType": "Business",

      "lastModified": "2022-03-22T09:39:35.44"
    },
    {
      "documentName": "proposal1.docx",
      "size": "3.9 MB",
      "documentType": "Business",
      "ExpiredDays": "10 days",
      "lastModified": "2022-09-08T09:39:35.44"
    },
  ];
  const columns1= [
    {
      title: 'Document Name',
      dataIndex: 'documentName',
      key: 'documentName',
      render: (text) => <span className="text-start">{text}</span>,
    },
    {
      title: 'Uploaded Date',
      dataIndex: 'lastModified',
      key: 'lastModified',
      render: (text) => (
        <span className="text-start">
          {new Date(text).toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          })}
        </span>
      ),
    },
    // {
    //   title: 'Expiration Days left',
    //   dataIndex: 'ExpiredDays',
    //   key: 'ExpiredDays',
    //   align: 'center',
    // },
  ];
  const updatedOptions = {
    ...option1,
    labels: ['Free Space', 'Used Space'],
  };
  const disabledDate = (value) => {
    const current = value.$d;
    return  differenceInCalendarDays(current, today) > 0;;
  };
  const typeViewMoreClicked = () => {
    setShowParent(false);
    setShowChild(true);
    setShowDocument(false);
  };
  const viewMoreClicked = () => {
    setShowDocument(true);
    setShowParent(false);
    setShowChild(true);
  };
  const callbackFunction = (item) => {
    setShowParent(true);
  }
  function getGenDocuments (){
    if(tenantID){
      dispatch(getGenDocument(tenantID))
    }
    setShowSuccessMsg1(true)
  }
  function getDocStorages (month, year){
    const numericMonth = parseInt(month, 10); 
    const numericYear = parseInt(year, 10);
    let inputJson ={
      "ProductID": productID,
      "TenantID": tenantID,
      "DocMonth": numericMonth,
      "DocYear": numericYear
    }
    dispatch(getDocStorageData(inputJson))
    setShowSuccessMsg(true);
  }
  function getRecentDoc(){
    let inputJson ={
      
      "objDocuInput": {
          "ProductID": productID,
          "TenantID": tenantID
      },
      "ServerSearchables": {
          "SearchData": searchTableVal,
          "PageNumber": pageIndex,
          "PageSize": pageSize,
          "OrderByColumn": "",
          "OrderBy": sortOrder
      },
      "objDocuList": []
  }
    dispatch(getRecentDocumentData(inputJson)) 
    setShowSuccessMsg2(true)
  }
  const saveDocType = () =>{
    let arrayOfObjects = []
    for (let i = 0; i < selectedDocValue?.length; i++) {
      const inputJson = {
        "DocumentTypeID": 0,
        "DocumentType":String(selectedDoclabel[i]),
        "DocTypeID": selectedDocValue[i],
        "TenantID": tenantID,
        "LocationID": locationID,
        "CreatedBy": appUserID
      };
      arrayOfObjects.push(inputJson);
    }
    dispatch(saveDocumentType(arrayOfObjects))
    setShowSuccessMsg4(true)
  }

  const handleCancel = () => {
    setOpenModal(false);
  };

  const getDocStorage =()=> {
    const userStorage = docStorage?.data?.usedSpace;
    setUsedStorage(docStorage?.data?.usedSpace);
    const totalStorage = docStorage?.data?.totalStorage;
    setTotalStorage(docStorage?.data?.totalStorage);
    let  TotalFreeStorage =  (totalStorage - userStorage) / totalStorage * 100
     TotalFreeStorage = Number((Math.round(TotalFreeStorage * 100) / 100).toFixed(2))
    setTotalFreeSpace(TotalFreeStorage);
    let UsedSpace = 100 - TotalFreeStorage
    UsedSpace = Number((Math.round(UsedSpace * 100) / 100).toFixed(2))
    setUsedSpace(UsedSpace);
    const DiscStatus = [TotalFreeStorage,UsedSpace]
    setDiscStatus(DiscStatus);
    const series = [];
    const temp = [];
    const temp1 = [];

    for (let i = 0; i < docStorage?.data?.sizeOut.length; i++) {
      if (typeof docStorage?.data?.sizeOut[i] !== 'number') {
        console.error('Invalid input');
        return;
      }
      const gigabytes = docStorage?.data?.sizeOut[i] / (1024 * 1024 * 1024);
      const val = gigabytes?.toFixed(3);
      temp.push(val);
      temp1.push(docStorage?.data?.dayOut[i]);
      setUsageDate(temp1);
      setUsageData(temp);
    }
  }
  const getDocumentTypeCalc=()=> {
    const updatedDocumentType =genDoc?.data?.map(item => {
      const freeSpace = (usedStorage - item.fileStorage) / usedStorage * 100;
      const formattedFreeSpace = Number((Math.round(freeSpace * 100) / 100).toFixed(1));
      const userspace = 100 - formattedFreeSpace;
      const formattedUserSpace = Number((Math.round(userspace * 100) / 100).toFixed(1));

      return {
        ...item,
        usedStorage: formattedUserSpace,
      };
    });
    setDocumentType(updatedDocumentType);
  }
  const getRecentFileSize = ()=>{
    const units = ['byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const tempRecentFileList = [];

    for (let i = 0; i < 5; i++) {
      let val = '';
      let l = 0;
      let n = parseInt(recDoc?.data?.objDocuList?.[i]?.docSize, 10) || 0;

      while (n >= 1024 && ++l) {
        n = n / 1024;
      }

      val = n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l];

      tempRecentFileList.push({
        ...recDoc?.data?.objDocuList[i],
        fileSize: val,
      });
    }
    setRecentFileList(tempRecentFileList);
  }
  const getSelectedMonth = (value) => {
    if (value && value.$d instanceof Date && !isNaN(value.$d)) {
      const month = value.$d.getMonth() + 1;
      const year = value.$d.getFullYear();
      setMonth(month);
      setYear(year);
      setDate(value);
      getDocStorages(month, year);
    } else {
      console.error('Invalid date:', value);
    }
  };
  useEffect(() => {
    if (successmsg) {
      setDocumentStorage(docStorage?.data)
      getDocStorage()
      setShowSuccessMsg(false);
    }
  }, [successmsg]);
  useEffect(() => {
    if (successmsg1) {
      setShowSuccessMsg1(false);
      getDocumentTypeCalc()
      setDocumentType(genDoc?.data)
    }
  }, [successmsg1]);

  useEffect(() => {
    if (successmsg2) {
      setRecentFileList(recDoc?.data?.objDocuList)
      setShowSuccessMsg2(false)
    }
  }, [successmsg2]); 
  useEffect(()=>{
    getRecentFileSize();
  },[recDoc])

  useEffect(()=>{
    getDocumentTypeCalc()
  },[genDoc])

  useEffect(()=>{
    const currentDate = new Date();
    const formattedMonth = currentDate.toLocaleString('en-US', { month: '2-digit' });
    const formattedYear = currentDate.toLocaleString('en-US', { year: 'numeric' });
    setMonth(formattedMonth);
    setYear(formattedYear);
    getDocStorages(formattedMonth,formattedYear );
    getGenDocuments();
    getRecentDoc();
    getDocumentTypeCalc()
  },[tenantID])

  useEffect(()=>{
  setUsedSpace(100 - totalFreeSpace);
  },[totalFreeSpace])

  useEffect(()=>{
    setUsedSpace(Number((Math.round(usedSpace * 100) / 100).toFixed(2)));
    setDiscStatus([totalFreeSpace, usedSpace]);
  },[usedSpace])

  return(
    <div className='docManager' >
      {
        showParent ?
        <>
          <div className='row docType '>
            <div className='col-md-9 '>
              <div className=' bg-white p-3 mb-4 rounded dataUsageGraph'>
                <div className="pb-2 d-flex justify-content-between">
                  <h6>Data Usage Statistics</h6>
                  <DatePicker.MonthPicker
                    value={date}
                    onChange={getSelectedMonth}
                    disabledDate={(current) => disabledDate(current)}
                  />
                </div>
                  {
                    !loading3?
                    <ReactApexChart
                    options={state.options}
                    series={state.series}
                    type="bar"
                    height="420"
                  />
                  :
                  <Spin className='h-100 d-flex justify-content-center align-items-center'></Spin>
                  }
               
              </div>
              <div className="contentCardParent bg-white p-3 mb-4 rounded">
                <div className="d-flex justify-content-between">
                  <h6 className=''>Document Types <PlusCircleFilled className='ps-1 plusIcon' size={20} onClick={() => handleModalOpen()} /></h6>
                  <div className='d-flex align-items-center'>
                    <div onClick={typeViewMoreClicked}>
                      <p className="viewMoreText pe-3 pt-2 text-primary">View More</p>
                    </div>
                  </div>
                </div>
                {
                  loading2 ?  <Spin className='h-100 d-flex justify-content-center align-items-center p-5'></Spin> :
                  <div className="row p-1">
                  {documentType?.slice(0, 3)?.map((item) => (
                    <div key={item?.docType} className="col contentCard p-4 rounded px-3 col-md-4 ms-4">
                      <div className="mt-3">
                        <span className="folderIcon">📁</span>
                        <span className="ps-1 innerCardContent">{item?.docType}</span>
                      </div>
                      <div className="mt-3 text-center">
                        <Progress percent={item?.usedStorage} status="active" />
                      </div>
                    </div>
                  ))}
                  </div>
                }
              </div>
            
              <div className="documentTableParent security pt-5 bg-white p-3 rounded">
                <div className="d-flex justify-content-between">
                  <h6>Recent Files</h6>
                  <div onClick={viewMoreClicked}>
                    <p className="viewMoreText pe-3 pt-2 text-primary">View More</p>
                  </div>
                </div>
                <Table rowKey="docID"
                  columns={columns}
                  dataSource={recentFileList?.slice(0, 5)}
                  // loading={loading2}
                  pagination={false}
                  showSizeChanger={true}
                  className="recentFileTable"
                  rowClassName={(record, index) => index % 2 === 0 ? 'even-row' : 'odd-row'}
                  loading={loading}
                />
              </div>   
            </div>

            <div className='col-md-3 bg-white storageDetails ps-0 pe-0'>
              <div className='col storageDetails bg-white p-3'>
                <div className="d-flex justify-content-between mb-2">
                  <h6>Storage Details</h6>
                </div>
                {
                  !loading3 ?
                  <ReactApexChart
                    series={option1?.series}
                    options={updatedOptions}
                    type="donut"
                    height={360}
                  />
                  :
                  <Spin className='h-100 d-flex justify-content-center align-items-center'></Spin>
                }
              </div>
              <div className="RetentionPolicyParent m-2 p-3 ">
                <div>
                  <h6>Retention Policy</h6>
                  <p>Retention Policy is to retain documents up to 10 years</p>
                  <div className="">
                    <Table rowKey="documentName"
                      className="retensionTable"
                      dataSource={expireFileList}
                      columns={columns1}
                      pagination={false}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </> 
        :
        <InnerDocManager data={{showDocument: showDocument , callbackFunction: callbackFunction,usedStorage:usedStorage, documentType:documentType}}/>
      }
      <Modal className='docTypeModal'
        title="Select Document Type"
        open={openModal}
        onCancel={handleCancel}
        width={500}
        maskClosable={true}
        footer={[
          <Button type="primary" className='dlv-cancel-btn'  onClick={() => handleCancel()} >
              Cancel
          </Button>,
          <Button key="submit" type="primary" className='dlv-save-btn' loading={loading4} onClick={() => saveDocType()} >
              Submit
          </Button>,
        ]}>
          <Divider className='header-divider' />
                <Form
                    form={form}
                    layout="vertical"
                >
                    <Form.Item className='w-100 ' label="" name="docType">
                        <Select 
                            size='large'
                            mode="multiple"
                            className='multi-select docTypeSelector'
                            // defaultValue={selectedDiag1}
                            // value={selectedDiag1}
                            filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            getPopupContainer={trigger => trigger.parentNode}
                            options={docTypeList}
                            onChange={handleSelectChange}
                            onDeselect={handleDeselect}
                        />
                    </Form.Item>
                </Form>
      </Modal>
    </div>
  )
}